// import library plugin
import { version, name } from '@/package'

import Peace from '@jk998/library'

import MetaInfo from 'vue-meta-info'

import { requestInterceptor, responseInterceptor } from '../library/http/interceptors'

// export boot install function
// async is optional
export default async ({ Vue }) => {
  // 注册 vue-meta-info
  Vue.use(MetaInfo)

  Vue.use(Peace, {
    config: {
      appName: name,
      appVersion: version
    },
    http: {
      // .e.g
      // requestInterceptor: { then: function() {}, catch: function() {} }
      // responseInterceptor: { then: function() {}, catch: function() {} }
      interceptors: {
        requestInterceptor: requestInterceptor,
        responseInterceptor: responseInterceptor
      }
    }
  })

  console.log(
    `%c ${'Library'} %c ${Peace.version} %c`,
    'background:#35495e ; padding: 1px; border-radius: 3px;  color: #fff',
    'background:#41b883 ; padding: 1px; border-radius: 3px;  color: #fff',
    'background:transparent'
  )
}
